/** Valores por defecto cuando no hay UTM en la URL ni en sesión (ajustar solo aquí por marca). */
export const UTM_DEFAULT_SOURCE = "directo";
export const UTM_DEFAULT_MEDIUM = "landing_campaña";

export function readSessionString(key) {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const v = sessionStorage.getItem(key);
    if (v == null) return null;
    const t = v.trim();
    return t === "" ? null : t;
  } catch {
    return null;
  }
}

function pickFromSearch(search, param) {
  const raw = new URLSearchParams(search).get(param);
  if (raw == null) return null;
  const t = String(raw).trim();
  return t === "" ? null : t;
}

/**
 * Resuelve utm_source y utm_medium desde la query y sessionStorage.
 * @param {string} [search] - Por defecto `window.location.search` en el navegador.
 */
export function resolveUtmSourceAndMedium(search) {
  const s =
    search !== undefined && search !== null
      ? String(search)
      : typeof window !== "undefined"
      ? window.location.search || ""
      : "";

  const fromUrlSource = pickFromSearch(s, "utm_source");
  const fromUrlMedium = pickFromSearch(s, "utm_medium");
  const storedSource = readSessionString("utm_source");
  const storedMedium = readSessionString("utm_medium");

  if (fromUrlSource == null && fromUrlMedium == null) {
    return {
      utm_source: storedSource ?? UTM_DEFAULT_SOURCE,
      utm_medium: storedMedium ?? UTM_DEFAULT_MEDIUM,
    };
  }

  return {
    utm_source: fromUrlSource ?? storedSource ?? UTM_DEFAULT_SOURCE,
    utm_medium: fromUrlMedium ?? storedMedium ?? UTM_DEFAULT_MEDIUM,
  };
}
